import React from 'react';
import { connect } from 'react-redux';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const DirectDebitMandateLogic = ({ isAccountHolder, isOnlySignatory, rendering }) => {
  const showBankDetails =
    (isAccountHolder === 'true' || isAccountHolder === true) &&
    (isOnlySignatory === 'true' || isOnlySignatory === true);

  return (
    <>
      {showBankDetails ? (
        <Placeholder name="bankDetails-content" rendering={rendering} />
      ) : (
        rendering.placeholders &&
        rendering.placeholders['directDebitMandate-content'] && (
          <Placeholder name="directDebitMandate-content" rendering={rendering} />
        )
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isAccountHolder: state.quoteData.prospectDetails.bankDetails.isAccountHolder,
    isOnlySignatory: state.quoteData.prospectDetails.bankDetails.isOnlySignatory,
  };
};

export { DirectDebitMandateLogic };
export default connect(mapStateToProps)(DirectDebitMandateLogic);
